module.exports = __webpack_public_path__ + "images/discover-student_José_Alvarez.jpg";